import { render } from "./ProfileIndex.vue?vue&type=template&id=394152d1&scoped=true"
import script from "./ProfileIndex.vue?vue&type=script&lang=js"
export * from "./ProfileIndex.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-394152d1"

export default script